"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EngagementsStore = _interopRequireDefault(require("crm_data/engagements/EngagementsStore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PinnedEngagementsStore = _interopRequireDefault(require("crm_ui/pinnedEngagements/stores/PinnedEngagementsStore"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _immutable = require("immutable");

var PinnedEngagementDependency = {
  propTypes: {
    subjectId: _propTypes.default.string.isRequired,
    objectType: _ObjectTypesType.default.isRequired
  },
  stores: [_PinnedEngagementsStore.default, _EngagementsStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType,
        subjectId = _ref.subjectId;

    var engagementId = _PinnedEngagementsStore.default.get((0, _immutable.Map)({
      objectType: objectType,
      subjectId: subjectId
    }));

    if (!engagementId) {
      return null;
    }

    return _EngagementsStore.default.get(engagementId);
  }
};
var _default = PinnedEngagementDependency;
exports.default = _default;
module.exports = exports.default;